import { PAYMENTMETHODS__MUTATIONS } from "../mutation-types";
import { PAYMENTMETHODS__ACTIONS } from '../action-types'
import { PAYMENTMETHODS__API } from '@/_helpers/urls'
import http from "@/_helpers/http";

// State
const state = {
    paymentMethods: []
};

// Mutations
const mutations = {
    [PAYMENTMETHODS__MUTATIONS.PAYMENTMETHODS](state, data) {
        state.paymentMethods = data
    },
};

const getters = {};

// Actions
const actions = {
    async [PAYMENTMETHODS__ACTIONS.PAYMENTMETHODS]({ commit }) {
        try {
            const { data } = await http().get(PAYMENTMETHODS__API.PAYMENTMETHODS);
            commit(PAYMENTMETHODS__MUTATIONS.PAYMENTMETHODS, data?.data?.paymentMethods);
        } catch (error) {
            console.error("Error fetching partner payment methods:", error);
        }
    }

};

export default {
    strict: process.env.NODE_ENV !== "production",
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
